import React from 'react'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { FormControl, FormHelperText } from '@material-ui/core';
export default function DatePicker(props) {

  const { name, label, value, error = null, onChange } = props

  const convertToDefEventPara = (name, value) => ({
    target: {
      name, value
    }
  })

  return (
    <FormControl variant="outlined"
      {...(error && { error: true })}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker disableToolbar variant="dialog" inputVariant="outlined"
          style={{ width: "100%", marginLeft: "0%" }}
          label={label}
          format="MM/dd/yyyy"
          name={name}
          value={value}
          onChange={date => onChange(convertToDefEventPara(name, date))}
        
        />
      </MuiPickersUtilsProvider>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  )
}
